import { useState } from 'react';
import {
    fetchOperatorConnection,
    operatorRequestHeaders,
    OperatorConnection
} from "../../../../../../../providers/operatorConnection";
import { Operator } from "../../../../../../../types/entities";

export const useEmailFinderActivityPanelManager= () => {
    const [loadingData, setLoadingData] = useState<boolean>(false);
    const [dataError, setDataError] = useState<string>('');
    const [tableData, setTableData] = useState<any>([]);

    /**
     * HQAPI-76. The host and the credential came off the Operator record, and `operator.token`
     * is the Operator's own standing secret - it opens every route on that Operator and never
     * expires. It is not served any more, so the panel asks HQ-API for a ticket per load.
     */
    async function loadData(operator: Operator, searchTerm: string = "", pageNumber: number = 1): Promise<void> {
        // setLoadingData(true)
        const connection: OperatorConnection = await fetchOperatorConnection(operator.id);
        let url: string  = `${connection.host}/system/status/ef/activity`;
        if (searchTerm !== "") {
            url += `?search_term=${searchTerm}&page_number=${pageNumber}`;
        } else {
            url += `?page_number=${pageNumber}`;
        }

        const request: Request = new Request(url, {
            method: 'GET',
            headers: operatorRequestHeaders(connection),
        });
        return fetch(request)
            .then( (response: Response): Promise<any> => {
                setLoadingData(false);
                if (response.status === 200) {
                    return response.json();
                } else {
                    return Promise.reject({ 'message': 'error' });
                }

            } )
            .catch ( (error: Error): void => {
                console.log(error);
            } );
    }

    return { loadingData, loadData, dataError, tableData };
}